var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, Event, html } from '@sick-davinci/ce-decorators';
import { style } from './RadioButton.style';
/**
 * A `davinci-radio-button` is a selection control that allow users to switch between options or to turn a setting on or off. 
 * Can be used within a toggle-group.
 * 
 * @example
 * ```html
 * <davinci-radio-button checked>checked</davinci-radio-button>
 * ```
 * 
 * @slot {*} label of the radio button
 */

export let RadioButton = (_dec = Component({
  tag: 'davinci-radio-button',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Event(), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Event(), _dec13 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class RadioButton extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "checked", _descriptor, this);

    _initializerDefineProperty(this, "disabled", _descriptor2, this);

    _initializerDefineProperty(this, "name", _descriptor3, this);

    _initializerDefineProperty(this, "value", _descriptor4, this);

    _initializerDefineProperty(this, "change", _descriptor5, this);

    _initializerDefineProperty(this, "input", _descriptor6, this);

    _defineProperty(this, "clickTrap", () => {
      if (!this.checked) {
        this.checked = true; // A native input-element of type 'radio' emits first the input-event and then the change-event.

        this.input.emit(true);
        this.change.emit(true);
      }
    });
  }

  componentConnected() {
    this.addEventListener('click', this.clickTrap);
  }

  componentDisconnected() {
    this.removeEventListener('click', this.clickTrap);
  }

  _keyDown(e) {
    if (e.key === 'Spacebar' || e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
    }
  }

  _keyUp(e) {
    if (e.key === 'Spacebar' || e.key === ' ' || e.key === 'Enter') {
      this.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: false
      }));
    }
  }

  render() {
    return html`
      <div
        tabindex=${!this.disabled ? '0' : '-1'}
        class="wrapper"
        @keydown=${this._keyDown}
        @keyup=${this._keyUp}
      >
        <svg viewBox="0 0 24 24">
          <circle class="rb_circle" cx="12" cy="12" r="11" />
          <circle class="rb_tick" cx="12" cy="12" r="6.5" />
        </svg>
        <div class="rb_label">
          <slot></slot>
        </div>
      </div>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "checked", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
